import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "..";
import { AccountOwnerSummaryRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "AM",
    dataIndex: "manager",
  },
  {
    title: "UP WTD",
    dataIndex: "up_wtd",
  },
  {
    title: "DOWN WTD",
    dataIndex: "down_wtd",
  },
  {
    title: "NEUT WTD",
    dataIndex: "neutral_wtd",
  },
  {
    title: "WTD ADS",
    dataIndex: "wtd_ads",
  },
  {
    title: "WTD DIFF",
    dataIndex: "wtd_diff",
  },
  {
    title: "WTD % DIFF",
    dataIndex: "wtd_perc_diff",
  },
  {
    title: "UP MTD",
    dataIndex: "up_mtd",
  },
  {
    title: "DOWN MTD",
    dataIndex: "down_mtd",
  },
  {
    title: "NEUT MTD",
    dataIndex: "neutral_mtd",
  },
  {
    title: "MTD ADS",
    dataIndex: "mtd_ads",
  },
  {
    title: "MTD DIFF",
    dataIndex: "mtd_diff",
  },
  {
    title: "MTD % DIFF",
    dataIndex: "mtd_perc_diff",
  },
  {
    title: "UP QTD",
    dataIndex: "up_qtd",
  },
  {
    title: "DOWN QTD",
    dataIndex: "down_qtd",
  },
  {
    title: "NEUT QTD",
    dataIndex: "neutral_qtd",
  },
  {
    title: "QTD ADS",
    dataIndex: "qtd_ads",
  },
  {
    title: "QTD DIFF",
    dataIndex: "qtd_diff",
  },
  {
    title: "QTD % DIFF",
    dataIndex: "qtd_perc_diff",
  },
];

type AccountTableProps = {
  loading: boolean;
  records: Array<AccountOwnerSummaryRecord>;
};

const AccountTable = ({ loading, records }: AccountTableProps): ReactElement => (
  <Table
    className="account-table"
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="manager"
    size="small"
    pagination={false}
    scroll={{ y: 250 }}
    rowClassName={rowClassName}
  />
);

export default AccountTable;
